import { render, staticRenderFns } from "./PrescriberForm.vue?vue&type=template&id=59d01bed&"
import script from "./PrescriberForm.vue?vue&type=script&lang=ts&"
export * from "./PrescriberForm.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriberForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports